
import React from 'react';
import { useTranslations } from 'use-intl';
import { Outlet } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export const PlatformAdminGuard: React.FC = () => {
  const t = useTranslations('consultantAuth.guards');
  const { platformRole, loading, signOut } = useAuth();

  if (loading || platformRole === null) return null;

  if (platformRole !== 'platform_admin' && platformRole !== 'consultant') {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <h1 className="text-2xl font-bold">{t('accessDenied')}</h1>
          <p className="text-muted-foreground mt-2">
            {t('requiresConsultant')}
          </p>
          <button
            onClick={() => signOut()}
            className="mt-6 px-4 py-2 text-sm font-medium rounded bg-primary text-white hover:opacity-90"
          >
            {t('signOut')}
          </button>
        </div>
      </div>
    );
  }

  return <Outlet />;
};
